import { createUseStyles } from "react-jss";
import * as Mixins from "../theme/Mixins";

export default createUseStyles({
    simulatedBanner: {
        background: "#EB6725",
        borderBottom: [[3, "solid", "#FF9300"]],
        boxSizing: "border-box",
        color: "#FFFFFF",
        composes: "simulated-banner",
        height: 38,
        left: ({ bounds }) => bounds.left,
        lineHeight: "38px",
        padding: [[0, 35]],
        position: "absolute",
        right: ({ bounds }) => bounds.right,
        top: 0,
        zIndex: 1,
    },
    simulatedBannerMessage: {
        composes: "simulated-banner__message",
        fontFamily: ({ theme }) => `"${theme.TextFont}", sans-serif`,
        fontSize: 14,
        padding: [[0, 15]],
    },
    surveyEngine: {
        "& .bg-primary": ({ theme }) => ({ background: theme.PrimaryColor }),
        "& .bg-secondary": ({ theme }) => ({ background: theme.SecondaryColor }),
        "& .fill-primary": ({ theme }) => ({ fill: theme.PrimaryColor }),
        "& .fill-secondary": ({ theme }) => ({ fill: theme.SecondaryColor }),
        "& .text-primary": ({ theme }) => ({ color: theme.PrimaryColor }),
        "& .text-secondary": ({ theme }) => ({ color: theme.SecondaryColor }),
        "& .flex": { flex: 1 },
        "& .clear": { display: "block", clear: "both" },
        "& label": {
            cursor: "inherit",
        },
        "& h1, h2, h3, h4, h5, h6": {
            margin: 0,
            padding: 0,
            fontFamily: ({ theme }) => `"${theme.TitleFont}", sans-serif`,
            fontWeight: ({ theme }) => Mixins.getFontWeight(theme.TitleFontVariant, 400),
            fontStyle: ({ theme }) =>
                theme.TitleFontVariant ? Mixins.getFontStyle(theme.TitleFontVariant) : "normal",
            textAlign: ({ theme }) => Mixins.getTextAlign(theme.TitleTextAlign),
        },
        "& h1": {
            fontSize: ({ theme }) =>
                Mixins.getFontSize(
                    theme.TitleFontSize * theme.HeaderSizes.H1,
                    `${theme.HeaderSizes.H1 * theme.TextFontSize}px`,
                ),
            lineHeight: ({ theme }) =>
                Mixins.getLineHeight(
                    theme.TitleFontSize * theme.HeaderSizes.H1,
                    32,
                    theme.BaseFontSize,
                ),
            marginBottom: "1.5em",
        },
        "& h2": {
            fontSize: ({ theme }) =>
                Mixins.getFontSize(
                    theme.TitleFontSize * theme.HeaderSizes.H2,
                    `${theme.HeaderSizes.H2 * theme.TextFontSize}px`,
                ),
            lineHeight: ({ theme }) =>
                Mixins.getLineHeight(
                    theme.TitleFontSize * theme.HeaderSizes.H2,
                    32,
                    theme.BaseFontSize,
                ),
            marginBottom: "0.5em",
        },
        "& h3": {
            fontSize: ({ theme }) =>
                Mixins.getFontSize(
                    theme.TitleFontSize * theme.HeaderSizes.H3,
                    `${theme.HeaderSizes.H3 * theme.TextFontSize}px`,
                ),
            lineHeight: ({ theme }) =>
                Mixins.getLineHeight(
                    theme.TitleFontSize * theme.HeaderSizes.H3,
                    32,
                    theme.BaseFontSize,
                ),
        },
        "& h4": {
            fontSize: ({ theme }) =>
                Mixins.getFontSize(
                    theme.TitleFontSize * theme.HeaderSizes.H4,
                    `${theme.HeaderSizes.H4 * theme.TextFontSize}px`,
                ),
            lineHeight: ({ theme }) =>
                Mixins.getLineHeight(
                    theme.TitleFontSize * theme.HeaderSizes.H4,
                    32,
                    theme.BaseFontSize,
                ),
        },
        background: ({ theme }) => theme.PageBackground,
        composes: "survey-engine",
        display: "block",
        fontFamily: ({ theme }) => `"${theme.TextFont}", sans-serif`,
        fontSize: ({ theme }) => Mixins.getFontSize(theme.TextFontSize),
        fontStyle: ({ theme }) => Mixins.getFontStyle(theme.TextFontVariant),
        fontWeight: ({ theme }) => Mixins.getFontWeight(theme.TextFontVariant, 400),
        lineHeight: ({ theme }) =>
            Mixins.getLineHeight(theme.TextFontSize, theme.LineHeight, theme.BaseFontSize),
        overflow: ({ mobilePreview }) => mobilePreview && "hidden",
        overflowY: "scroll",
        position: "absolute",
        bottom: ({ bounds }) => bounds.bottom,
        left: ({ bounds }) => bounds.left,
        right: ({ bounds }) => bounds.right,
        top: ({ bounds }) => bounds.top,
        textSizeAdjust: "100%",
    },
});
